import React, { useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { MATFILE_ENDLESS_TYPE } from 'pxc-editor-core/constants';
import { buildMatrixTemplate } from '@/helpers';
import { getOnlyDiffProps } from '@/helpers/common';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';
import { addNewMatrix } from '@/actions';
import MatrixFormatForm from './MatrixFormatForm';

const MatrixFormatFormContainer = props => {
  const {
    pages,
    pagesSelection,
    addNewMatrix,
    updateSelectedSectionsProps,
    compRef,
    ...restProps
  } = props;
  const template = buildMatrixTemplate();
  const matfileTemplate = getBuildedMatfileTemplate();
  const isMMmaterial = /^MM/.test(matfileTemplate?.name || '');
  const isEndlessMaterial = matfileTemplate?.type === MATFILE_ENDLESS_TYPE;
  const isFixedCellWidth = isMMmaterial && isEndlessMaterial;
  const onChangeRef = useRef();
  const [defaultData, setDefaultData] = useState({
    ...template,
    isMatrixFixedCellWidth: isFixedCellWidth
  });
  const [changes, setChanges] = useState({});

  // define external api
  compRef.current = {
    hasChanges: () => !!Object.keys(changes).length,
    submit: () => addNewMatrix(defaultData),
  };

  onChangeRef.current = data => {
    const newChanges = getOnlyDiffProps(defaultData, { ...changes, ...data });

    setChanges(newChanges);
    setDefaultData({ ...defaultData, ...newChanges });
  };

  const cachedOnChange = useCallback(data => onChangeRef.current(data), []);

  if (defaultData) {
    return (
      <MatrixFormatForm
        {...defaultData}
        {...changes}
        {...restProps}
        isEndlessMaterial={isEndlessMaterial}
        onChange={cachedOnChange}
      />
    );
  }
  return null;
};

const mapStateToProps = state => ({
  pages: state.core.pages,
  pagesSelection: state.core.pagesSelection,
  userSizeUnit: state.core.userSizeUnit,
});

const mapDispatchToProps = dispatch => ({
  addNewMatrix: data => dispatch(addNewMatrix(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MatrixFormatFormContainer);
